const GET_AZURE_ALERT_RULES = "GET_AZURE_ALERT_RULES";
const GET_AZURE_ALERT_RULES_SUCCESS = "GET_AZURE_ALERT_RULES_SUCCESS";
const GET_AZURE_ALERT_RULES_ERROR = "GET_AZURE_ALERT_RULES_ERROR";

export {
  GET_AZURE_ALERT_RULES,
  GET_AZURE_ALERT_RULES_SUCCESS,
  GET_AZURE_ALERT_RULES_ERROR,
};
